import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleColposcopy from '../../schemas/module-colposcopy.json';

class ModuleValueColposcopy extends ModuleValueGeneral {
  date_of_birth?: string;
  date_of_referral?: string;
  colposcopy_date?: string;
  biopsy_date?: string;
  date_of_treatment?: string;
}

export class SchemaModuleColposcopy extends SchemaModuleGeneral<ModuleValueColposcopy> {
  schema: JSONSchema<ModuleValueColposcopy>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleColposcopy );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue( 'colposcopy_date', this.fieldHandlerCopyValue( 'biopsy_date' ).bind( this ) );
  }

  setupValidators() {
    super.setupValidators();
    this.validatorDateComparison( 'date_of_referral', 'date_of_birth', '>' );
    this.validatorDateComparison( 'colposcopy_date', 'date_of_birth', '>' );
    this.validatorDateComparison( 'colposcopy_date', 'date_of_referral', '>=' );
    this.validatorDateComparison( 'biopsy_date', 'date_of_birth', '>' );
    this.validatorDateComparison( 'biopsy_date', 'date_of_referral', '>=' );
    this.validatorDateComparison( 'date_of_treatment', 'date_of_birth', '>' );
    this.validatorDateComparison( 'date_of_treatment', 'date_of_referral', '>=' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-colposcopy.ts